import index from '@/pages/index/views/index.vue'
export default {
    path: '/main',
    name: 'index',
    component: index,
    meta: {
        title: '首页'
    },
    children: [
        {
            path: 'position',
            name: 'position',
            component: () => import(/* webpackChunkName: "position" */ "@/pages/index/views/Position.vue"),
            meta: {
                title: '职位'
            },
        },
        {
            path: 'talentPool',
            name: 'talentPool',
            component: () => import(/* webpackChunkName: "talentPool" */ "@/pages/index/views/talentPool.vue"),
            meta: {
                title: '人才库'
            },
        },
        {
            path: 'Workbench',
            name: 'Workbench',
            component: () => import(/* webpackChunkName: "Workbench" */ "@/pages/index/views/Workbench.vue"),
            meta: {
                title: '工作台'
            },
        },
        {
            path: 'Personal',
            name: 'Personal',
            component: () => import(/* webpackChunkName: "Personal" */ "@/pages/index/views/Personal.vue"),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/main',
            redirect: 'position'
        },
    ]
}
